import { NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';

@Component({
  standalone: true,
  selector: 'app-sk-profile-checkbox',
  templateUrl: './sk-profile-checkbox.component.html',
  styleUrls: ['./sk-profile-checkbox.component.less'],
  viewProviders: [{provide: ControlContainer, useExisting: FormGroupDirective}],
  imports: [ReactiveFormsModule, NgIf]
})
export class SkProfileCheckboxComponent implements OnInit {

  @Input() name: string;
  @Input() label: string;

  constructor() { }

  ngOnInit() {
  }

}
